// TikTok Pixel Event Tracking Utility
declare global {
  interface Window {
    ttq?: {
      track: (eventName: string, properties?: any) => void;
      page: () => void;
    };
  }
}

const trackTikTokEvent = (eventName: string, properties: any) => {
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track(eventName, properties);
  }
};

// ViewContent - Product page view
export const trackViewContent = (product: {
  id: string;
  title: string;
  price: number;
  category?: string;
}) => {
  trackTikTokEvent('ViewContent', {
    contents: [
      {
        content_id: String(product.id),
        content_name: product.title,
        content_category: product.category || '',
        quantity: 1,
        price: Number(product.price)
      }
    ],
    value: Number(product.price),
    currency: 'EGP'
  });
};

// AddToCart
export const trackAddToCart = (product: {
  id: string;
  title: string;
  price: number;
  quantity?: number;
  variantId?: string;
}) => {
  const qty = product.quantity || 1;
  const price = Number(product.price);
  
  trackTikTokEvent('AddToCart', {
    contents: [
      {
        content_id: String(product.id),
        content_name: product.title,
        quantity: qty,
        price: price
      }
    ],
    value: price * qty,
    currency: 'EGP'
  });
};

// InitiateCheckout
export const trackInitiateCheckout = (cart: {
  items: Array<{ productId: string; quantity: number }>;
  subtotal: number;
}) => {
  trackTikTokEvent('InitiateCheckout', {
    contents: cart.items.map(item => ({
      content_id: String(item.productId),
      quantity: item.quantity
    })),
    value: Number(cart.subtotal),
    currency: 'EGP'
  });
};

// CompletePayment
export const trackCompletePayment = (order: {
  orderNumber: string;
  total: number;
  items: Array<{ productId: string; quantity: number }>;
}) => {
  trackTikTokEvent('CompletePayment', {
    event_id: order.orderNumber,
    contents: order.items.map(item => ({
      content_id: String(item.productId),
      quantity: item.quantity
    })),
    value: Number(order.total),
    currency: 'EGP'
  });
};

// AddToWishlist
export const trackAddToWishlist = (product: {
  id: string;
  title: string;
  price: number;
}) => {
  trackTikTokEvent('AddToWishlist', {
    contents: [
      {
        content_id: String(product.id),
        content_name: product.title,
        quantity: 1,
        price: Number(product.price)
      }
    ],
    value: Number(product.price),
    currency: 'EGP'
  });
};
